/**
 * Held items: weapons
 */
import * as THREE from 'three';

export function buildHeld_bua_nham_thach(lib, itemGroup) {
  // BÚA TẠ NHAM THẠCH LỬA (Magma War Hammer)
  const stoneMat = new THREE.MeshStandardMaterial({ color: '#1c1917', roughness: 0.8 });
  const lavaGlowMat = new THREE.MeshBasicMaterial({ color: '#f97316' });
  const handleMat = new THREE.MeshStandardMaterial({ color: '#451a03', roughness: 0.7 });
  lib.disposables.push(stoneMat, lavaGlowMat, handleMat);

  // Cán búa dài
  const hGeo = new THREE.CylinderGeometry(0.025, 0.025, 0.85, 8);
  const hMesh = new THREE.Mesh(hGeo, handleMat);
  hMesh.position.set(0, 0.15, 0);
  itemGroup.add(hMesh);

  // Đầu búa đá đen nứt nham thạch
  const headGeo = new THREE.BoxGeometry(0.24, 0.22, 0.38);
  const headMesh = new THREE.Mesh(headGeo, stoneMat);
  headMesh.position.set(0, 0.5, 0);
  itemGroup.add(headMesh);

  // Lõi dung nham đỏ vàng xuyên tâm
  const coreGeo = new THREE.BoxGeometry(0.25, 0.08, 0.4);
  const coreMesh = new THREE.Mesh(coreGeo, lavaGlowMat);
  coreMesh.position.set(0, 0.5, 0);
  itemGroup.add(coreMesh);

  lib.disposables.push(hGeo, headGeo, coreGeo);
}

export function buildHeld_kiem_plasma(lib, itemGroup) {
  // KIẾM PLASMA LƯỢNG TỬ (Quantum Plasma Blade)
  const hiltMat = new THREE.MeshStandardMaterial({ color: '#0f172a', metalness: 0.9, roughness: 0.2 });
  const bladeMat = new THREE.MeshBasicMaterial({ color: '#38bdf8' });
  lib.disposables.push(hiltMat, bladeMat);

  // Chuôi kiếm cơ khí
  const hiltGeo = new THREE.CylinderGeometry(0.022, 0.025, 0.22, 8);
  const hilt = new THREE.Mesh(hiltGeo, hiltMat);
  hilt.position.set(0, -0.05, 0);
  itemGroup.add(hilt);

  // Lưỡi kiếm plasma phát sáng
  const bladeGeo = new THREE.BoxGeometry(0.045, 0.72, 0.018);
  const blade = new THREE.Mesh(bladeGeo, bladeMat);
  blade.position.set(0, 0.38, 0);
  itemGroup.add(blade);

  lib.disposables.push(hiltGeo, bladeGeo);
}

export function buildHeld_sung_xung_kich(lib, itemGroup) {
  // SÚNG XUNG KÍCH NĂNG LƯỢNG (Pulse Blaster)
  const gunMat = new THREE.MeshStandardMaterial({ color: '#334155', metalness: 0.8, roughness: 0.2 });
  const neonMat = new THREE.MeshBasicMaterial({ color: '#a855f7' });
  lib.disposables.push(gunMat, neonMat);

  // Thân súng
  const bodyGeo = new THREE.BoxGeometry(0.08, 0.16, 0.38);
  const body = new THREE.Mesh(bodyGeo, gunMat);
  body.position.set(0, 0.05, 0.1);
  itemGroup.add(body);

  // Nòng súng kép
  const barrelGeo = new THREE.CylinderGeometry(0.022, 0.022, 0.22, 8);
  barrelGeo.rotateX(Math.PI / 2);
  const barrel = new THREE.Mesh(barrelGeo, gunMat);
  barrel.position.set(0, 0.08, 0.35);
  itemGroup.add(barrel);

  // Dải pin năng lượng phát sáng tím
  const cellGeo = new THREE.BoxGeometry(0.085, 0.04, 0.18);
  const cell = new THREE.Mesh(cellGeo, neonMat);
  cell.position.set(0, 0.11, 0.08);
  itemGroup.add(cell);

  lib.disposables.push(bodyGeo, barrelGeo, cellGeo);
}

export function buildHeld_dinh_ba_song_am(lib, itemGroup) {
  // ĐINH BA SÓNG ÂM ĐẠI DƯƠNG (Sonic Wave Trident)
  const staffMat = new THREE.MeshStandardMaterial({ color: '#0891b2', metalness: 0.8, roughness: 0.2 });
  const tipMat = new THREE.MeshBasicMaterial({ color: '#22d3ee' });
  lib.disposables.push(staffMat, tipMat);

  // Cán đinh ba dài
  const sGeo = new THREE.CylinderGeometry(0.02, 0.02, 1.1, 8);
  const staff = new THREE.Mesh(sGeo, staffMat);
  staff.position.set(0, 0.25, 0);
  itemGroup.add(staff);

  // 3 Chạc sóng âm
  [-0.12, 0, 0.12].forEach((tx, idx) => {
    const len = idx === 1 ? 0.35 : 0.26;
    const prGeo = new THREE.BoxGeometry(0.03, len, 0.025);
    const pr = new THREE.Mesh(prGeo, tipMat);
    pr.position.set(tx, 0.8 + len / 2, 0);
    itemGroup.add(pr);
    lib.disposables.push(prGeo);
  });

  lib.disposables.push(sGeo);
}

export function buildHeld_truong_anh_sang(lib, itemGroup) {
  // TRƯỢNG THIÊN SỨ ÁNH SÁNG (Seraph Light Staff)
  const goldMat = new THREE.MeshStandardMaterial({ color: '#f59e0b', metalness: 0.9, roughness: 0.15 });
  const orbMat = new THREE.MeshBasicMaterial({ color: '#ffffff' });
  lib.disposables.push(goldMat, orbMat);

  // Cán gậy vàng
  const rodGeo = new THREE.CylinderGeometry(0.02, 0.02, 1.15, 8);
  const rod = new THREE.Mesh(rodGeo, goldMat);
  rod.position.set(0, 0.3, 0);
  itemGroup.add(rod);

  // Quả cầu hào quang lơ lửng trên ngọn
  const orbGeo = new THREE.BoxGeometry(0.14, 0.14, 0.14);
  const orb = new THREE.Mesh(orbGeo, orbMat);
  orb.position.set(0, 0.92, 0);
  itemGroup.add(orb);

  // Vòng tròn halo bao quanh ngọn gậy
  const haloGeo = new THREE.TorusGeometry(0.16, 0.02, 6, 16);
  const halo = new THREE.Mesh(haloGeo, goldMat);
  halo.position.set(0, 0.92, 0);
  halo.rotation.y = Math.PI / 4;
  itemGroup.add(halo);

  lib.disposables.push(rodGeo, orbGeo, haloGeo);
}

export function buildHeld_khiên_tinh_the(lib, itemGroup) {
  // KHIÊN THẠCH ANH TINH THỂ LĂNG KÍNH (Prismatic Crystal Shield)
  const crystalMat = new THREE.MeshStandardMaterial({ color: '#e879f9', metalness: 0.7, roughness: 0.15 });
  const coreMat = new THREE.MeshBasicMaterial({ color: '#fdf4ff' });
  lib.disposables.push(crystalMat, coreMat);

  // Khối khiên lục giác
  const shGeo = new THREE.CylinderGeometry(0.28, 0.28, 0.05, 6);
  shGeo.rotateX(Math.PI / 2);
  const sh = new THREE.Mesh(shGeo, crystalMat);
  sh.position.set(0.05, 0.18, 0.12);
  itemGroup.add(sh);

  // Tâm pha lê phát sáng
  const cGeo = new THREE.BoxGeometry(0.12, 0.12, 0.07);
  const cMesh = new THREE.Mesh(cGeo, coreMat);
  cMesh.position.set(0.05, 0.18, 0.13);
  itemGroup.add(cMesh);

  lib.disposables.push(shGeo, cGeo);
}

export function buildHeld_gay_mam_song(lib, itemGroup) {
  // GẬY MẦM SỐNG SINH HỌC (Bio Flora Staff)
  const woodMat = new THREE.MeshStandardMaterial({ color: '#78350f', roughness: 0.8 });
  const leafMat = new THREE.MeshBasicMaterial({ color: '#22c55e' });
  lib.disposables.push(woodMat, leafMat);

  const wGeo = new THREE.CylinderGeometry(0.022, 0.025, 1.0, 8);
  const wMesh = new THREE.Mesh(wGeo, woodMat);
  wMesh.position.set(0, 0.25, 0);
  itemGroup.add(wMesh);

  // Chồi lá non xòe nở trên đỉnh gậy
  [-1, 1].forEach((side) => {
    const lfGeo = new THREE.BoxGeometry(0.08, 0.14, 0.02);
    const lf = new THREE.Mesh(lfGeo, leafMat);
    lf.position.set(side * 0.06, 0.78, 0);
    lf.rotation.set(0.2, 0, side * 0.4);
    itemGroup.add(lf);
    lib.disposables.push(lfGeo);
  });

  lib.disposables.push(wGeo);
}

export function buildHeld_luoi_hai_bong_dem(lib, itemGroup) {
  // LƯỠI HÁI HƯ KHÔNG (Void Scythe)
  const staffMat = new THREE.MeshStandardMaterial({ color: '#18181b', roughness: 0.6 });
  const bladeMat = new THREE.MeshStandardMaterial({ color: '#581c87', metalness: 0.8, roughness: 0.2 });
  const glowMat = new THREE.MeshBasicMaterial({ color: '#c084fc' });
  lib.disposables.push(staffMat, bladeMat, glowMat);

  // Cán lưỡi hái đen dài
  const sGeo = new THREE.CylinderGeometry(0.022, 0.022, 1.25, 8);
  const staff = new THREE.Mesh(sGeo, staffMat);
  staff.position.set(0, 0.35, 0);
  itemGroup.add(staff);

  // Lưỡi hái cong ngang
  const bGeo = new THREE.BoxGeometry(0.55, 0.12, 0.025);
  const bMesh = new THREE.Mesh(bGeo, bladeMat);
  bMesh.position.set(0.22, 0.95, 0);
  bMesh.rotation.z = -0.25;
  itemGroup.add(bMesh);

  // Viền tím phát quang trên lưỡi
  const gGeo = new THREE.BoxGeometry(0.52, 0.03, 0.03);
  const gMesh = new THREE.Mesh(gGeo, glowMat);
  gMesh.position.set(0.22, 0.98, 0);
  gMesh.rotation.z = -0.25;
  itemGroup.add(gMesh);

  lib.disposables.push(sGeo, bGeo, gGeo);
}

export function buildHeld_cung_bang(lib, itemGroup) {
  // CUNG TINH THỂ BĂNG (Cryo Bow)
  const iceMat = new THREE.MeshStandardMaterial({ color: '#38bdf8', roughness: 0.1, metalness: 0.85 });
  const strMat = new THREE.MeshBasicMaterial({ color: '#ffffff' });
  lib.disposables.push(iceMat, strMat);

  // Cánh cung cong
  const c1Geo = new THREE.BoxGeometry(0.04, 0.45, 0.04);
  const c1 = new THREE.Mesh(c1Geo, iceMat);
  c1.position.set(0, 0.35, 0.12);
  c1.rotation.x = 0.35;
  itemGroup.add(c1);

  const c2Geo = new THREE.BoxGeometry(0.04, 0.45, 0.04);
  const c2 = new THREE.Mesh(c2Geo, iceMat);
  c2.position.set(0, -0.05, 0.12);
  c2.rotation.x = -0.35;
  itemGroup.add(c2);

  // Dây cung ánh sáng
  const strGeo = new THREE.CylinderGeometry(0.005, 0.005, 0.78, 6);
  const str = new THREE.Mesh(strGeo, strMat);
  str.position.set(0, 0.15, 0.02);
  itemGroup.add(str);

  lib.disposables.push(c1Geo, c2Geo, strGeo);
}

export function buildHeld_binh_doc_duoc(lib, itemGroup) {
  // BÌNH XỊT ĐỘC TỐ AXIT (Toxic Sprayer)
  const canMat = new THREE.MeshStandardMaterial({ color: '#166534', roughness: 0.4 });
  const nozMat = new THREE.MeshStandardMaterial({ color: '#0f172a', metalness: 0.8 });
  const glowMat = new THREE.MeshBasicMaterial({ color: '#84cc16' });
  lib.disposables.push(canMat, nozMat, glowMat);

  const canGeo = new THREE.CylinderGeometry(0.08, 0.08, 0.28, 12);
  const can = new THREE.Mesh(canGeo, canMat);
  can.position.set(0, 0.14, 0);
  itemGroup.add(can);

  const nozGeo = new THREE.BoxGeometry(0.04, 0.06, 0.12);
  const noz = new THREE.Mesh(nozGeo, nozMat);
  noz.position.set(0, 0.28, 0.06);
  itemGroup.add(noz);

  const indGeo = new THREE.BoxGeometry(0.09, 0.14, 0.02);
  const ind = new THREE.Mesh(indGeo, glowMat);
  ind.position.set(0, 0.14, 0.075);
  itemGroup.add(ind);

  lib.disposables.push(canGeo, nozGeo, indGeo);
}

export function buildHeld_gay_dong_ho_cat(lib, itemGroup) {
  // TRƯỢNG ĐỒNG HỒ CÁT THỜI GIAN (Hourglass Staff)
  const staffMat = new THREE.MeshStandardMaterial({ color: '#b45309', metalness: 0.8, roughness: 0.3 });
  const glassMat = new THREE.MeshPhysicalMaterial({ color: '#ffffff', transparent: true, opacity: 0.6 });
  const sandMat = new THREE.MeshBasicMaterial({ color: '#facc15' });
  lib.disposables.push(staffMat, glassMat, sandMat);

  const stGeo = new THREE.CylinderGeometry(0.02, 0.02, 1.1, 8);
  const staff = new THREE.Mesh(stGeo, staffMat);
  staff.position.set(0, 0.25, 0);
  itemGroup.add(staff);

  // Quả đồng hồ cát trên ngọn
  const hgGeo = new THREE.BoxGeometry(0.12, 0.22, 0.12);
  const hg = new THREE.Mesh(hgGeo, glassMat);
  hg.position.set(0, 0.85, 0);
  itemGroup.add(hg);

  // Cát vàng bên trong
  const sGeo = new THREE.BoxGeometry(0.08, 0.14, 0.08);
  const sMesh = new THREE.Mesh(sGeo, sandMat);
  sMesh.position.set(0, 0.85, 0);
  itemGroup.add(sMesh);

  lib.disposables.push(stGeo, hgGeo, sGeo);
}

export function buildHeld_dai_dao_long_hoa(lib, itemGroup) {
  // ĐẠI ĐAO LONG HỎA VẢY RỒNG (Dragon Flame Glaive)
  const poleMat = new THREE.MeshStandardMaterial({ color: '#450a0a', metalness: 0.6, roughness: 0.4 });
  const bladeMat = new THREE.MeshStandardMaterial({ color: '#991b1b', metalness: 0.8, roughness: 0.2 });
  const fireMat = new THREE.MeshBasicMaterial({ color: '#ea580c' });
  lib.disposables.push(poleMat, bladeMat, fireMat);

  // Cán đao dài
  const pGeo = new THREE.CylinderGeometry(0.025, 0.025, 1.2, 8);
  const pole = new THREE.Mesh(pGeo, poleMat);
  pole.position.set(0, 0.3, 0);
  itemGroup.add(pole);

  // Lưỡi đao vát rộng
  const bGeo = new THREE.BoxGeometry(0.16, 0.65, 0.03);
  const blade = new THREE.Mesh(bGeo, bladeMat);
  blade.position.set(0.06, 0.85, 0);
  itemGroup.add(blade);

  // Sóng lửa rực trên sống đao
  const fGeo = new THREE.BoxGeometry(0.06, 0.58, 0.035);
  const fire = new THREE.Mesh(fGeo, fireMat);
  fire.position.set(0.12, 0.85, 0);
  itemGroup.add(fire);

  lib.disposables.push(pGeo, bGeo, fGeo);
}

export function buildHeld_may_quet_luong_tu(lib, itemGroup) {
  // MÁY QUÉT LƯỢNG TỬ (Quantum Scanner)
  const bodyMat = new THREE.MeshStandardMaterial({ color: '#1e293b', metalness: 0.85, roughness: 0.2 });
  const scrMat = new THREE.MeshBasicMaterial({ color: '#06b6d4' });
  lib.disposables.push(bodyMat, scrMat);

  const bGeo = new THREE.BoxGeometry(0.14, 0.22, 0.08);
  const b = new THREE.Mesh(bGeo, bodyMat);
  b.position.set(0, 0.12, 0);
  itemGroup.add(b);

  const scrGeo = new THREE.BoxGeometry(0.11, 0.14, 0.02);
  const scr = new THREE.Mesh(scrGeo, scrMat);
  scr.position.set(0, 0.14, 0.042);
  itemGroup.add(scr);

  lib.disposables.push(bGeo, scrGeo);
}

export function buildHeld_song_dao_cang_bo(lib, itemGroup) {
  // SONG ĐAO CÀNG BỌ SẮC BÉN (Chitin Scythe Blades)
  const chitinMat = new THREE.MeshStandardMaterial({ color: '#065f46', metalness: 0.7, roughness: 0.2 });
  const edgeMat = new THREE.MeshBasicMaterial({ color: '#34d399' });
  lib.disposables.push(chitinMat, edgeMat);

  [-1, 1].forEach((side) => {
    const bladeGeo = new THREE.BoxGeometry(0.08, 0.48, 0.02);
    const blade = new THREE.Mesh(bladeGeo, chitinMat);
    blade.position.set(side * 0.1, 0.24, 0);
    blade.rotation.set(0, 0, -side * 0.3);
    itemGroup.add(blade);

    const edgeGeo = new THREE.BoxGeometry(0.02, 0.46, 0.025);
    const edge = new THREE.Mesh(edgeGeo, edgeMat);
    edge.position.set(side * 0.13, 0.24, 0);
    edge.rotation.set(0, 0, -side * 0.3);
    itemGroup.add(edge);

    lib.disposables.push(bladeGeo, edgeGeo);
  });
}

export const weapons_held_builders = {
  bua_nham_thach: buildHeld_bua_nham_thach,
  kiem_plasma: buildHeld_kiem_plasma,
  sung_xung_kich: buildHeld_sung_xung_kich,
  dinh_ba_song_am: buildHeld_dinh_ba_song_am,
  truong_anh_sang: buildHeld_truong_anh_sang,
  khiên_tinh_the: buildHeld_khiên_tinh_the,
  gay_mam_song: buildHeld_gay_mam_song,
  luoi_hai_bong_dem: buildHeld_luoi_hai_bong_dem,
  cung_bang: buildHeld_cung_bang,
  binh_doc_duoc: buildHeld_binh_doc_duoc,
  gay_dong_ho_cat: buildHeld_gay_dong_ho_cat,
  dai_dao_long_hoa: buildHeld_dai_dao_long_hoa,
  may_quet_luong_tu: buildHeld_may_quet_luong_tu,
  song_dao_cang_bo: buildHeld_song_dao_cang_bo
};
